var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-left"},[_c('div',{staticClass:"bodyPage"},[_vm._v(" TESTE ")])])}
var staticRenderFns = []

export { render, staticRenderFns }